import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";
import TestimonialsAdmin from "@/components/TestimonialsAdmin";
import AboutAdmin from "@/components/AboutAdmin";
import PricingAdmin from "@/components/admin/PricingAdmin";
import PackagesAdmin from "@/components/admin/PackagesAdmin";
import PromosAdmin from "@/components/admin/PromosAdmin";
import ContentAdmin from "@/components/admin/ContentAdmin";

const FIELDS = [["company_name", "Nama Perusahaan"], ["company_address", "Alamat"], ["whatsapp", "WhatsApp"], ["email", "Email"], ["vat_no", "VAT No."],
  ["bank_name", "Bank"], ["bank_account_no", "No. Rekening"], ["bank_account_name", "Atas Nama"]];

export function AdminSettings() {
  const { t, reloadSite } = useApp();
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data.settings)); }, []);
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/settings", s); setS(data.settings); reloadSite(); toast.success(t("saved")); return true; }
    catch { toast.error(t("failed")); return false; } finally { setSaving(false); }
  };
  if (!s) return <div className="text-slate-500">{t("loading")}</div>;
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between sticky top-14 z-20 bg-slate-50/90 backdrop-blur py-2"><h1 className="text-3xl font-bold">{t("settings")}</h1>
        <Button onClick={save} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700" data-testid="settings-save">{saving ? "..." : t("save")}</Button></div>
      <Tabs defaultValue="prices">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="prices" data-testid="tab-prices">{t("price_list")}</TabsTrigger>
          <TabsTrigger value="packages" data-testid="tab-packages">{t("packages")}</TabsTrigger>
          <TabsTrigger value="promos" data-testid="tab-promos">{t("promos")}</TabsTrigger>
          <TabsTrigger value="content" data-testid="tab-content">{t("site_content")}</TabsTrigger>
          <TabsTrigger value="company" data-testid="tab-company">{t("company_bank")}</TabsTrigger>
          <TabsTrigger value="about" data-testid="tab-about">{t("about_us")}</TabsTrigger>
          <TabsTrigger value="testimonials" data-testid="tab-testimonials">{t("testimonial_text")}</TabsTrigger>
        </TabsList>
        <TabsContent value="prices"><PricingAdmin s={s} setS={setS} /></TabsContent>
        <TabsContent value="packages"><PackagesAdmin s={s} setS={setS} onSaved={save} /></TabsContent>
        <TabsContent value="promos"><PromosAdmin s={s} setS={setS} /></TabsContent>
        <TabsContent value="content"><ContentAdmin s={s} setS={setS} /></TabsContent>
        <TabsContent value="about"><AboutAdmin s={s} setS={setS} /></TabsContent>
        <TabsContent value="testimonials"><TestimonialsAdmin /></TabsContent>
        <TabsContent value="company">
          <Card><CardContent className="p-6 grid md:grid-cols-2 gap-4">
            {FIELDS.map(([k, l]) => <div key={k}><Label>{l}</Label><Input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`set-${k}`} /></div>)}
            <div className="md:col-span-2"><Label>{t("invoice_note")}</Label><Input value={s.invoice_note || ""} onChange={(e) => setS({ ...s, invoice_note: e.target.value })} data-testid="set-invoice_note" /></div>
          </CardContent></Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
